import { render, staticRenderFns } from "./specialTopic.vue?vue&type=template&id=23b07518&"
import script from "./specialTopic.vue?vue&type=script&lang=js&"
export * from "./specialTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports